import React from 'react'
import { QuestionnaireFormLabel } from 'spa/member/components/QuestionnaireFormLabel'
import { Input } from 'spa/member/components/Input'

export type Props = {
  name: string,
  label: string | React.ReactNode,
  noBadge?: boolean,
  annotationNote?: string,
  required?: boolean,
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>,
  labelProps?: React.InputHTMLAttributes<HTMLLabelElement>,
  inputSize?: 'default' | 'small',
  rules?: any,
  dataCy?: string
}

export const StyledKarteInputForm: React.FC<Props> = (props: Props) => {
  return (
    <div className="w-full" data-cy={props.dataCy}>
      <QuestionnaireFormLabel {...props.labelProps} htmlFor={props.name} label={props.label} noBadge={props.noBadge} required={props.required} annotationNote={props.annotationNote} />
      <Input
        {...props.inputProps}
        id={props.name}
        name={props.name}
        required={props.required}
        inputSize={props.inputSize || 'default'}
        rules={props.rules}
      />
    </div>
  )
}
